import type { KeyLevelsAction } from './actions';
import type { KeyLevelsState } from './types';
import type {
    AlphaEyeKeyLevel,
    AlphaEyeKeyLevelCategory,
} from '@thinkalpha/platform-ws-client/contracts/widget/alpha-eye.js';

/** Canonical category order — used to deduplicate-and-sort `availableCategories`. */
export const CATEGORY_ORDER = [
    'pivots',
    'std-dev',
    'fibonacci',
    'rsi',
    'highs-lows',
    'ohlc',
] as const satisfies readonly AlphaEyeKeyLevelCategory[];

/** Categories present in the given levels, in canonical order with duplicates removed. */
export function deriveAvailableCategories(levels: readonly AlphaEyeKeyLevel[]): readonly AlphaEyeKeyLevelCategory[] {
    if (levels.length === 0) return [];
    const seen = new Set<AlphaEyeKeyLevelCategory>();
    for (const level of levels) seen.add(level.category);
    return CATEGORY_ORDER.filter((c) => seen.has(c));
}

export function reducer(state: KeyLevelsState, action: KeyLevelsAction): KeyLevelsState {
    switch (action.type) {
        case 'SET_ACTIVE_CATEGORIES':
            if (state.activeCategories === action.value) return state;
            return { ...state, activeCategories: action.value };
    }
}
